//
//
//
//
//
//
//
//

export default {
  name: 'UploadFroms',
  components: {
    UploadIndex: function UploadIndex() {
      return import('@/components/uploadPicture/index.vue');
    }
  },
  data: function data() {
    return {
      visible: false,
      callback: function callback() {}
    };
  },
  methods: {
    handleClose: function handleClose() {
      this.visible = false;
    },
    getImage: function getImage(img) {
      this.callback(img);
      this.visible = false;
    }
  }
};